import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import CustomizedSteppers from "./Stepper";
import SubscriptionCards from "./SubscriptionCards";
import SubscriptionHeader from "../Header/SubscriptionHeader";
import Checkout from "../Checkout/Checkout";
import { useNavigate } from "react-router-dom";

export default function Subscription_Type() {
  const navigate = useNavigate();
  const [type, setType] = useState(false);
  const [showsubType, setshowsubType] = useState(true);
  const [selectSubType, setselectSubType] = useState("")
  // useEffect(() => {
  //   let user = localStorage.getItem('user');
  //   if(!user){
  //     localStorage.clear();
  //     navigate('/login');
  //   }
  // }, []);

  return (
    <>
      <Box component="container">
        <Box pb="42px">
          <SubscriptionHeader setshowsubTypeFunc={setshowsubType} showsubType={showsubType} />
        </Box> 
        {showsubType ? (
          <Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CustomizedSteppers />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", mt: "56px" }}>
              <Typography
                sx={{ fontSize: "20px", fontWeight: "400", pb: "24px" }}
              >
                Select Period do you want to subscribe
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <SubscriptionCards
                setshowsubTypeFunc={setshowsubType}
                CheckTypeFunc={setType}
                setselectSubType={setselectSubType}
                selectSubType={selectSubType}
              />
            </Box>
          </Box>
        ) : type ? (
          <Checkout
            setshowsubTypeFunc={setshowsubType}
            CheckTypeFunc={setType}
            selectSubType={selectSubType}
          />
        ) : (
          ""
        )}
      </Box>
    </>
  );
}
